import { render, staticRenderFns } from "./IncomeAndOutgoAgriFieldDetail.html?vue&type=template&id=2006c4c4&scoped=true&external"
import script from "./IncomeAndOutgoAgriFieldDetail.ts?vue&type=script&lang=ts&external"
export * from "./IncomeAndOutgoAgriFieldDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./IncomeAndOutgoAgriFieldDetail.css?vue&type=style&index=0&id=2006c4c4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006c4c4",
  null
  
)

export default component.exports